import React from "react";
import { AnimatedHeight } from "./animatedHeight";
import { extractAnimatedHeightProps } from "./util";

const combineStyles = (divStyle, style) => {
  return {...divStyle, ...style};
};

const combineInnerProps = (innerProps, combinedStyles) => {
  return {...innerProps, style: combinedStyles};
};

export const AnimatedToggle = (props) => {
  const {innerProps, outerProps, show, ...otherProps } = extractAnimatedHeightProps(props);
  const divStyle = {height: show ? "auto" : "0px"};
  const { style: innerStyle = {} } = innerProps || {};

  const combinedStyles = combineStyles(divStyle, innerStyle);
  return (
    <AnimatedHeight
      outerProps={{...outerProps, "aria-hidden": !show, "data-disable-tab": !show}}
      innerProps={combineInnerProps(innerProps, combinedStyles)}
      {...otherProps}
    />
  );
};

AnimatedToggle.defaultProps = {
  element: "div"
};